// React
import React from 'react';
// Material-UI
import { Typography } from '@material-ui/core';
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 *
 * @typedef {Object} Props
 * @property {string} label Etiqueta de botón
 */

/**
 * Botón de carga
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const TituloSeccion = ({ 
    label = '',
}) => {
    // Idioma

    // Estados

    // Vista
    return (
        <Typography variant="subtitle2" style={{ fontSize: 15 }}>
            {label}
        </Typography>
    );
};
